"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeFunctions = void 0;
var time = require("../constants/time.json");
exports.timeFunctions = {
    days: function (multiplier) {
        return multiplier * time.DAY;
    },
    hours: function (multiplier) {
        return multiplier * time.HOUR;
    },
    milliseconds: function (multiplier) {
        return multiplier;
    },
    minutes: function (multiplier) {
        return multiplier * time.MINUTE;
    },
    seconds: function (multiplier) {
        return multiplier * time.SECOND;
    },
    weeks: function (multiplier) {
        return multiplier * time.WEEK;
    }
};
//# sourceMappingURL=time.js.map